import {SupportContactFormService} from "webform/gen/supportContactForm";
import {GroupedItems} from "webform/components";
import groupBy from "lodash.groupby";

export interface UserPersonaSingleItem {
    id: string;
    title: string;
    type: typeof SupportContactFormService.UserPersonaDataType.SINGLE;
    persona: SupportContactFormService.UserPersona;
    additional_input?: boolean;
}

export interface UserPersonaGroupItem {
    id: string;
    title: string;
    type: typeof SupportContactFormService.UserPersonaDataType.GROUP;
    groupTitle: string;
    group: UserPersonaSingleItem[];
}
export type UserPersonaItem = UserPersonaSingleItem | UserPersonaGroupItem;

export const userPersonaBuilder = (
    userPersonas: SupportContactFormService.UserPersonaData[] | null,
): Array<GroupedItems<UserPersonaItem>> => {
    const groupedItems = Object.entries(
        groupBy<SupportContactFormService.UserPersonaData>(userPersonas, (item) => item.category),
    );

    return groupedItems.map(([category, userPersonasInCategory]) => ({
        id: category,
        title: userPersonasInCategory[0]?.category_title ?? "",
        items: userPersonasInCategory.map((item) =>
            item.type === SupportContactFormService.UserPersonaDataType.GROUP
                ? {
                      id: item.title,
                      title: item.title,
                      type: item.type,
                      groupTitle: item.group_title,
                      group: item.group.map((g) => ({
                          type: SupportContactFormService.UserPersonaDataType.SINGLE,
                          title: g.subtitle,
                          id: g.id,
                          persona: g.id,
                      })),
                  }
                : {
                      id: item.id,
                      title: item.title,
                      type: item.type,
                      persona: item.id,
                      additional_input: item.additional_input,
                  },
        ),
    }));
};
